import request from '@hb/sharp-request';
import { authUrl, newGatewayUrl } from '@/constant';
import { SYSTEM_CODE } from '@/constant/system';
import { BusinessInfoExtra, PageSourceEnum, SyncUserInfoData } from './types';

/** 新版v2登录接口网关 */
const authV2Config = {
  baseURL: authUrl.replace('/auth', '/api'),
};
const authConfig = {
  baseURL: authUrl,
};

/**
 * 登录相关接口不必传token，在此强制清空
 * 避免因用户有缓存token时，影响服务的正常处理(验证码输入错误时，返回的msg不符合预期)
 */
const forceClearTokenConfig = (config: Dictionary) => ({
  ...config,
  getToken: () => '',
});

// 发送登录短信验证码
export const getLoginCode = (
  mobile: string,
  source?: string,
  capText = '',
): Promise<{
  ok: boolean;
  imageStatus?: number;
  imageCaptcha?: string;
}> => request.postGate(
  'user.account.sendCodeV2',
  {
    mobile,
    source,
    capText,
    systemCode: SYSTEM_CODE,
  },
  forceClearTokenConfig(authV2Config),
);

// 验证短信验证码登录
export const login = (
  mobile: string,
  code: string,
  notShowErrMsg?:boolean,
): Promise<NativeModel.OriginUserInfo> => request.postGate(
  'user.account.h5Login',
  {
    mobile,
    code,
    systemCode: SYSTEM_CODE,
  },
  forceClearTokenConfig(
    notShowErrMsg
      ? { ...authV2Config, showErrMsg: undefined }
      : authV2Config,
  ),
);

export const validatePicCode = (
  mobile: string,
  capText: string,
  source?: string,
): Promise<{
  ok: boolean;
  imageStatus: number; // 2 表示图片验证码错误
  imageCaptcha: string;
}> => request.postGate(
  'user.account.sendCodeV2',
  {
    mobile,
    capText,
    source,
    systemCode: SYSTEM_CODE,
  },
  forceClearTokenConfig(authV2Config),
);

export const getPicValidateCode = (
  mobile: string,
): Promise<{
  imageCaptcha: string;
}> => request.postGate(
  'user.account.imageCaptcha',
  {
    mobile,
  },
  authConfig,
);

export const getVoiceCode = (mobile: string): Promise<unknown> => request.postGate(
  'user.account.sendVoiceCode',
  {
    mobile,
  },
  authV2Config,
);

// 是否命中ABTest，参考：https://yapi.hellobike.cn/project/3411/interface/api/82883
export const checkABTest = (expName: string): Promise<number> => request.postGate(
  'f.common.ab.get',
  {
    exp: expName,
  },
  {
    baseURL: newGatewayUrl,
    withCredentials: false,
    showLoading: undefined,
  },
);

// 是否登录手机号可用(提前还款-短信手机号是否一致)
export const checkMobile = (mobile: string): Promise<{ available: boolean }> => request.postGate(
  'f.autarky.advance.checkMobile',
  {
    userPhone: mobile,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

/**
 * 获取信贷业务-公共信息
 * yapi地址: https://yapi.hellobike.cn/project/3415/interface/api/401471
 * 接口服务: 杨钊
 */
export const getBusinessInfo = (pageSource?: PageSourceEnum)
: Promise<BusinessInfoExtra> => request.postGate(
  'f.business.info.extra',
  {
    pageSource,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
    showErrMsg: undefined,
  },
);

/**
 * 用户进入首页后,通知资产服务,调用平台同步拉取二要素、异步拉取ocr照片
 * yapi地址:
 * 接口服务: 杨钊
 */
export const getSyncUserInfo = (): Promise<SyncUserInfoData> => request.postGate(
  'f.sync.userInfo',
  {},
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
    showErrMsg: undefined,
  },
);

const CommonApi = {
  getLoginCode,
  login,
  validatePicCode,
  getPicValidateCode,
  getVoiceCode,
  checkABTest,
  checkMobile,
};

export default CommonApi;
